const steps = [
  {
    num: "1",
    title: "Call & Describe",
    description: "Tell us what's wrong. Most issues diagnosed in 5 min.",
  },
  {
    num: "2",
    title: "Phone Quote",
    description: "Honest flat-rate quote. No surprise fees.",
  },
  {
    num: "3",
    title: "Same-Day Visit",
    description: "Tech arrives with common parts. One visit usually.",
  },
  {
    num: "4",
    title: "30-Day Guarantee",
    description: "Workmanship guaranteed 30 days.",
  },
];

export default function ProcessSection() {
  return (
    <section className="w-full bg-[#fefce8] py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-4xl font-black text-secondary mb-4">
            How a Hardware Repair Works
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((s) => (
            <div key={s.num} className="text-center">
              <div className="w-12 h-12 flex items-center justify-center bg-primary rounded-full mx-auto mb-4">
                <span className="text-lg font-bold text-white">{s.num}</span>
              </div>
              <h3 className="text-lg font-bold text-secondary mb-2">{s.title}</h3>
              <p className="text-sm text-[#374151] leading-relaxed">{s.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}